import { render } from "./statsBoard.vue?vue&type=template&id=177100b0&scoped=true"
import script from "./statsBoard.vue?vue&type=script&lang=js"
export * from "./statsBoard.vue?vue&type=script&lang=js"

import "./statsBoard.vue?vue&type=style&index=0&id=177100b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-177100b0"]])

export default __exports__